function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaw = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.705,3.209L32.664,3.209C33.764,3.209 34.653,4.098 34.653,5.198C34.653,6.299 33.764,7.188 32.664,7.188L25.6,7.188C25.277,8.792 24.176,10.117 22.715,10.751L22.715,29.074L32.664,29.074C33.764,29.074 34.653,29.964 34.653,31.064C34.653,32.165 33.764,33.054 32.664,33.054L8.788,33.054C7.687,33.054 6.798,32.165 6.798,31.064C6.798,29.964 7.687,29.074 8.788,29.074L18.736,29.074L18.736,10.751C17.275,10.11 16.174,8.786 15.851,7.188L8.788,7.188C7.687,7.188 6.798,6.299 6.798,5.198C6.798,4.098 7.687,3.209 8.788,3.209L16.746,3.209C17.654,2.003 19.097,1.219 20.726,1.219C22.355,1.219 23.797,2.003 24.705,3.209ZM8.651,12.243L4.006,21.116L13.569,21.116L8.924,12.243C8.899,12.193 8.844,12.162 8.788,12.162C8.732,12.162 8.682,12.193 8.651,12.243ZM8.788,9.178C9.956,9.178 11.026,9.824 11.567,10.857L16.404,20.09C16.597,20.45 16.784,20.96 16.746,21.57C16.703,22.322 16.448,23.758 15.204,24.996C13.942,26.252 11.909,27.085 8.788,27.085C5.666,27.085 3.633,26.252 2.371,25.002C1.127,23.758 0.866,22.328 0.829,21.576C0.792,20.967 0.984,20.457 1.171,20.096L6.008,10.857C6.549,9.824 7.619,9.178 8.788,9.178ZM32.664,12.162C32.608,12.162 32.558,12.193 32.527,12.243L27.882,21.116L37.445,21.116L32.8,12.243C32.775,12.193 32.72,12.162 32.664,12.162ZM29.884,10.857C30.425,9.824 31.495,9.178 32.664,9.178C33.832,9.178 34.902,9.824 35.443,10.857L40.28,20.09C40.473,20.45 40.66,20.96 40.622,21.57C40.579,22.322 40.324,23.758 39.08,24.996C37.818,26.252 35.785,27.085 32.664,27.085C29.542,27.085 27.509,26.252 26.247,25.002C25.003,23.758 24.742,22.328 24.705,21.576C24.668,20.967 24.86,20.457 25.047,20.096L29.884,10.857Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/law.df13df317e3587780b261b7a0b1f3d7a.svg";